
import { createHash } from 'crypto';
import { keccak256 } from 'js-sha3';

export const hashTypes = [
        'SHA1',
        'SHA256',
        'HASH256',
        'RIPEMD160',
        'SHA3', //TODO: double-check correctness
    ];

export function bufferHash(content, type = 'SHA256') {
    switch( type ) {
        case 'HASH256':
            return createHash('sha256').update(createHash('sha256').update(content).digest()).digest();
        case 'SHA3':
            return keccak256(content);
        default:
            return createHash(type).update(content).digest();

    }
};

export default function hash(content, type = 'SHA256') {
    const h = bufferHash(content, type);
    if( typeof h === 'string' ) {
        return h;
    }
    else {
        return h.toString('hex');
    }
};





// WEBPACK FOOTER //
// ./src/reducers/hasher.js